import React from "react";
import ImageSlider from "../SlideShowImage/ImageSlider";
import images from "../../../images";

export const CardQuestLocation = ({
  businessAvatar = "",
  handleFavoriteQuest,
  isFavorited,
  address = "",
  businessName,
  onFavoriteLocation,
  locationId,
  thumnail,
  handleNavigateToDetails,
}) => {
  const handleFavoriteClick = () => {
    if (onFavoriteLocation && locationId) {
      onFavoriteLocation(locationId);
    } else {
      console.warn("Missing onFavoriteLocation or locationId:", {
        onFavoriteLocation: !!onFavoriteLocation,
        locationId,
      });
    }
  };

  const imagePaths = Array.isArray(thumnail)
    ? thumnail
        .find(
          (t) =>
            Array.isArray(t.thumbnail_data) &&
            t.thumbnail_data.some((thumb) => thumb.file_path)
        )
        ?.thumbnail_data?.map((t) => t.file_path)
        .filter(Boolean) || []
    : [];

  return (
    <article
      onClick={handleNavigateToDetails}
      className="max-w-[480px] bg-white rounded-md border border-[#E9E6E4] border-solid self-stretch cursor-pointer "
    >
      <div className="w-full relative rounded-md">
        {/* <ImageSlider  imageHeight={"h-[70.85px]"} /> */}
        <ImageSlider
          images={imagePaths}
          imageHeight={"h-[70.85px]"}
          applyImageOverlay={false}
        />
        <div
          className={`flex absolute ${"top-[18px]"}  left-[18px] flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20`}
        >
          <figure className="flex shrink-0 self-stretch my-auto" />
          {businessAvatar !== "" ? (
            <div
              className={`relative w-[70px] h-[70px] rounded-md bg-[lightgray] bg-cover bg-no-repeat bg-center`}
              style={{
                backgroundImage: `url(${process.env.REACT_APP_URL_IMAGE}/${businessAvatar})`,
              }}
            ></div>
          ) : (
            <div
              className={`relative w-[70px] h-[70px] rounded-md bg-[lightgray] bg-cover bg-no-repeat bg-center`}
              style={{ backgroundImage: `url(${images.DefaultImageQuest})` }}
            ></div>
          )}
        </div>
      </div>
      <div className="flex flex-col p-[18px] gap-1.5 mt-[12px]">
        <div className="flex justify-between items-center">
          <span className="text-[#333] text-xl font-medium">
            {businessName ? businessName : ""}
          </span>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleFavoriteClick();
            }}
            className="flex-col self-start text-xs font-bold text-center text-black rounded-none h-[24px] w-[24px] cursor-pointer"
          >
            <img
              src={
                isFavorited === true
                  ? images.Heart02ActiveIcon
                  : images.HeartGrayIcon
              }
              alt="heart-icon"
            />
          </div>
        </div>
        {address && (
          <div className="flex justify-start items-start gap-1.5">
            <img
              src={images.MapPinIcon}
              alt="map-pin-icon"
              className="h-[20px] w-[20px]"
            />
            <p className="text-base font-medium text-[#A0A0A0]">
              {address ? address : ""}
            </p>
          </div>
        )}
      </div>
    </article>
  );
};
export default CardQuestLocation;
